import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

/**
 * Recursively mark form control as done
 * IF control is form group or array, child controls will also be validated
 */
export function markFormControlAsDone(formControl: AbstractControl): void {
    if (formControl.disabled) {
        return;
    }
    formControl.markAsDirty({ onlySelf: true });
    formControl.markAsTouched({ onlySelf: true });
    formControl.updateValueAndValidity({ onlySelf: true });
    if (formControl instanceof FormArray) {
        formControl.controls.forEach((control) => markFormControlAsDone(control));
    }
    if (formControl instanceof FormGroup) {
        Object.keys(formControl.controls).forEach((key) => markFormControlAsDone(formControl.controls[key]));
    }
}
